export default __webpack_public_path__ + "static/media/EM0240.34I-21688_-15057_0.a6e12d80.jpg";